import BaseModel from "@/api/models/BaseModel";
import { env } from "@/composables/config";
import { useSessionMessageStore } from "./stores/sessionMessage";
import router from "@/router";
import translationHandler from "./composables/handlers/TranslationHandler";

/**
 * SecurityManager
 * Adds additional security measures
 */
export default class SecurityManager extends BaseModel{

  constructor() {
    super();

    this.max_security     = env('APP_MAX_SECURITY');
    this.redirect_to      = env('APP_REDIRECT_TO_SECURITY');
    this.redirect_message = env('APP_REDIRECT_SECURITY_MESSAGE');
  }

  /**
   * Checks if max_security is true
   * @returns {Boolean}
   */
  mustRaiseSecurity() {
    return this.max_security;
  }

  /**
   * Sets some security measures to application
   */
  raiseMaxSecurity() {
    this.disableConsoleLogs();
    this.detectDevTools();

    document.addEventListener("keydown", this.disableDevTools);
    document.addEventListener("contextmenu", (event) => event.preventDefault());
  }

  /**
   * Disables console.logs
   */
  disableConsoleLogs() {
    console.log = function () {};
    console.warn = function () {};
    console.error = function () {};
  }

  /**
   * Disables some keyboard shortcuts
   */
  disableDevTools(event) {
    if (
      event.key.toUpperCase() === "F12" ||
      (event.ctrlKey && event.shiftKey && event.key.toUpperCase() === "I") ||
      (event.ctrlKey && event.key.toUpperCase() === "U") ||
      (event.ctrlKey && event.shiftKey && event.key.toUpperCase() === "I") ||
      (event.ctrlKey && event.shiftKey && event.key.toUpperCase() === "J") ||
      (event.ctrlKey && event.key.toUpperCase()  === "S")
    ) {
      event.preventDefault();
    }
  }

  /**
   * Detects if DevTools are open, redirecting the page if true
   * Note: redirects to defined env 'VUE_APP_REDIRECT_TO_SECURITY'
   */
  async detectDevTools() {
    let timer = 1000;
    const threshold = 160;
    setInterval(() => {
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold
      ) {
        const sessionMessageStore = useSessionMessageStore();
        sessionMessageStore.errorMessage(translationHandler.translate(this.redirect_message, 'ucfirst'));
        router.push({path: this.redirect_to});
      }
      timer = 1000;
    }, timer);
  }

  /**
   * Details in how to offuscate code
   * Note: this must be executed by hand
   */
  offuscateCode() {
    // Execute at the terminal: javascript-obfuscator ./dist --output ./dist-obfuscated
    // after that, point the server folder to "dist-obfuscated"
  }
}